import React, { Component } from 'react';
import { connect } from 'react-redux';
import Scrollbars from '../../components/utility/customScrollBar';
import { SidebarContent, BottomDivider } from './sidebarNotification.style';
import IntlMessages from '../../components/utility/intlMessages';
import Divider from '../../components/uielements/dividers';
import NotificationSection from './notificationSection';

class TopbarNotifications extends Component {
  render() {
    const {
      topTitle,
      bottomTitle,
      topNotifications,
      bottomNotifications,
      totalBottom,
      totalTop,
      loadTop,
      loadBottom,
      loadingBottom,
      loadingTop,
      height,
      loadingNotifications,
      closeDrawer
    } = this.props;
    return (
      <SidebarContent
        className="topbarMessage withImg"
        style={{ height: height - 65 }}
      >
        <div className="dropdownBody">
          <Scrollbars style={{ height: '100%' }}>
            <NotificationSection
              title={topTitle}
              items={topNotifications}
              notificationCount={totalTop}
              loadMore={loadTop}
              loading={loadingTop}
              loadingAll={loadingNotifications}
              errorMessage="You have no pending notifications"
              sectionHeight={bottomNotifications && '50%'}
              closeDrawer={closeDrawer}
            />
            {bottomNotifications &&
              <React.Fragment>
                <BottomDivider />
                <NotificationSection
                  title={bottomTitle}
                  items={bottomNotifications}
                  notificationCount={totalBottom}
                  loadMore={loadBottom}
                  loading={loadingBottom}
                  loadingAll={loadingNotifications}
                  errorMessage="You have not completed any notifications"
                  sectionHeight={bottomNotifications && '50%'}
                  closeDrawer={closeDrawer}
                />
              </React.Fragment>
            }
          </Scrollbars>
        </div>
      </SidebarContent>
    );
  }
}

export default connect(
	state => ({
		...state.App,
		customizedTheme: state.ThemeSwitcher.topbarTheme,
		height: state.App.height,
	}),
)(TopbarNotifications);



// WEBPACK FOOTER //
// ./src/containers/Topbar/topbarNotifications.js